__webpack_require__.p = "https://sc1.checkpoint.com/uc/app_bundles/techpoint/";